import { getData, getForBlobData, sendData } from './apiService';
import NotificationManager from 'react-notifications/lib/NotificationManager';

const BASE_URL = 'custom-duty-invoice-transaction';

export async function getAll(query) {
  try {
    let response = await getData(`${BASE_URL}/get-all?${new URLSearchParams(query).toString()}`);
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function exportData(query) {
  return await getForBlobData(`${BASE_URL}/csv-export?${new URLSearchParams(query).toString()}`, {
    responseType: 'blob',
  });
}

export async function getTransactions(query) {
  try {
    let response = await getData(`${BASE_URL}/get-transactions?${new URLSearchParams(query).toString()}`);
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function getTransactionCount(query) {
  try {
    let response = await getData(`${BASE_URL}/get-transaction-count?${new URLSearchParams(query).toString()}`);
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function makePurchase(data) {
  try {
    let response = await sendData(`${BASE_URL}/make-purchase`, data, 'POST', false);
    return response;
  } catch (e) {
    NotificationManager.error(e.response?.data?.message || 'Opps. Something wrong');
    return false;
  }
}

export async function update(data) {
  try {
    let response = await sendData(`${BASE_URL}/update-transaction`, data, 'PATCH');
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function deleteData(_id) {
  try {
    let response = await sendData(`${BASE_URL}/delete`, { _id: _id });
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}

export async function getCurrencyOptions() {
  try {
    let response = await getData(`${BASE_URL}/get-currency-option`);
    return response;
  } catch (e) {
    NotificationManager.error('Opps. Something wrong');
    return false;
  }
}
